import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Star } from 'lucide-react';
import Reveal from '../components/Reveal';
import { TESTIMONIALS } from '../data/mock';

export default function Testimonials() {
  return (
    <div className="bg-[var(--bg)]">
      <section className="pt-36 pb-16 border-b border-[var(--line)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> 005 — Testimonials</span>
          <Reveal>
            <h1 className="font-display text-7xl md:text-[150px] leading-[0.92] mt-6">In their <span className="font-display-italic text-[var(--coral)]">words.</span></h1>
          </Reveal>
          <div className="grid md:grid-cols-12 gap-8 mt-10">
            <p className="md:col-span-6 md:col-start-7 text-[18px] text-[var(--ink-mute)] leading-relaxed">
              Clients, partners and consultants on what it has been like to work with the Bespoke studio.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-rs grid md:grid-cols-2 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.id} delay={(i % 2) * 80} className="soft-card p-10 tilt">
              <div className="flex items-center justify-between">
                <div className="flex gap-1">
                  {[1,2,3,4,5].map((n) => <Star key={n} size={16} className="fill-[var(--coral)] text-[var(--coral)]" />)}
                </div>
                <div className="font-tag text-[var(--ink-mute)]">{String(i+1).padStart(2,'0')} / {String(TESTIMONIALS.length).padStart(2,'0')}</div>
              </div>
              <div className="font-display text-[var(--coral)] text-7xl leading-none mt-4">“</div>
              <p className="font-display text-2xl md:text-3xl leading-snug -mt-4">{t.quote}</p>
              <div className="mt-8 pt-6 border-t border-[var(--line)] flex items-center justify-between gap-4">
                <div>
                  <div className="font-display text-xl">{t.author}</div>
                  <div className="font-tag text-[var(--ink-mute)] mt-1">{t.role}</div>
                </div>
                <div className="font-tag text-[var(--ink-mute)] text-right">{t.project}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 bg-[var(--navy)] text-white">
        <div className="container-rs flex flex-wrap items-center justify-between gap-10">
          <div className="font-display text-4xl md:text-6xl leading-tight max-w-2xl">Become our <span className="font-display-italic text-[var(--coral)]">next testimonial.</span></div>
          <Link to="/contact" className="pill pill-coral"><span>Start a Project</span><ArrowUpRight size={14} /></Link>
        </div>
      </section>
    </div>
  );
}
